// @ts-nocheck
import * as React from "react";

const BulbOutline: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" aria-hidden="true" focusable="false">
            <path
                d="m53.3 63.1 1.4-10.8c-1.3.7-3.5.7-4.7-1.1-1.2 1.8-3.4 1.8-4.8 1.1l1.4 10.8h6.7z
                   M68.2 49.9h9.2
                   M65.8 40.7l7.9-4.5
                   M59.1 34.1l4.6-7.9
                   M50 31.6v-9.1
                   M40.9 34.1l-4.6-7.9
                   M34.2 40.7l-7.9-4.5
                   M31.8 49.9h-9.2
                   M42.4 63.1h15.2v7.6H42.4z"
                fill="none"
                stroke="currentColor"
                strokeMiterlimit="10"
                strokeWidth="2"
            />
            <path
                d="M43.9 70.6h12.2v6.9H43.9z
                   M57.6 63.1c4.2-2.6 7-7.2 7-12.4 0-8.1-6.5-14.6-14.6-14.6s-14.6 6.5-14.6 14.6c0 5.3 2.8 9.9 7 12.4"
                fill="none"
                stroke="currentColor"
                strokeMiterlimit="10"
                strokeWidth="2"
            />
        </svg>
    );
};

export default React.memo(BulbOutline);
